/**
 * /fiscal/* - router-shell do modulo Fiscal (Fase 14 - ADR-0032).
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import NotasFiscaisLista from "./NotasFiscais/Lista";
import NotaFiscalDetalhe from "./NotasFiscais/Detalhe";
import ConfiguracaoFiscal from "./Configuracao";


export default function FiscalShell() {
  return (
    <Routes>
      <Route index element={<Navigate to="notas-fiscais" replace />} />
      <Route path="notas-fiscais" element={<NotasFiscaisLista />} />
      <Route path="notas-fiscais/:id" element={<NotaFiscalDetalhe />} />
      <Route path="configuracao" element={<ConfiguracaoFiscal />} />
      <Route path="*" element={<Navigate to="notas-fiscais" replace />} />
    </Routes>
  );
}
